import React from 'react';

import {
  PracticeInformationDesktop,
  PracticeInformationMobile
} from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceHeader/PracticeInformation';

import PatientInformation from './PatientInformation';

const ReceiptHeader = ({ receipt }) => {
  return (
    <div className="flex justify-center overflow-hidden bg-neutral-50 print:bg-white print:!p-0">
      <div className="print:!page-break-before flex h-full w-full flex-col bg-white print:w-full ">
        <PracticeInformationDesktop
          practice={receipt?.practice}
          id={receipt?.transaction?.id}
          title="Receipt"
        />
        <PracticeInformationMobile
          practice={receipt?.practice}
          id={receipt?.transaction?.id}
          title="Receipt"
        />
        {receipt?.patient && (
          <PatientInformation
            lowercase
            id={receipt?.id}
            patient={receipt?.patient}
            transaction={receipt?.transaction}
            timezone={receipt?.practice?.timezone}
          />
        )}
      </div>
    </div>
  );
};

export default ReceiptHeader;
